import { EnumColor } from '@40seas/frontend/common/providers';
import { CreditReviewNotesStatus } from '@40seas/entities/credit-reviews';

export const creditReviewNotesStatusColorMapping = {
    [CreditReviewNotesStatus.Pending]: 'default',
    [CreditReviewNotesStatus.Done]: 'success',
} as { [key in CreditReviewNotesStatus]: EnumColor };
